module.exports = __webpack_public_path__ + "img/monois_book2.ba6cd6a3.jpg";